import * as React from 'react';
import DashboardComponent from './components/DashboardComponent.jsx'
import { useState, useEffect } from 'react';

const Dashboard = () => {
	const [filters, setFilters] = useState([]);

	useEffect(() => {
		api.getDashboardFilter().then((res) => {
			setFilters(res.data);
		})
	}, []);

		
	return <DashboardComponent filters={filters}/>;
};

export default Dashboard;